export default __webpack_public_path__ + "static/media/index.ef97aa78.less";